<template>
  <div v-if="jobDetails !== null" class="mt-4">
    <div  class="relative mb-4 card top_primary_card bg-primary font-bold text-white p-2 rounded-xl  w-full ">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <span v-if="jobDetails.isVipJob" class="text-warning heading-4 pr-1"><i class="fa-solid fa-star"></i></span>
          <span class="heading-2 overFlowParaA">{{jobDetails.jobTitle}}</span>
          <!-- Individual title edit icon removed - use "Edit Job" button instead -->
          <!-- <div class=" text-primary heading-6 cursor-pointer bg-white px-2 py-1 ml-2 rounded-xl" @click="updateJobValue()">
            <i class="fa-solid fa-pen-to-square"></i>
          </div> -->
        </div>
        <div class="flex items-center gap-2">
          <!-- <h1 class="heading-3 text-center">Job # {{jobDetails.jobNumber}}</h1> -->

          <button v-if="userDetail.isAdmin || userDetail.isOwner"
            class="btn btn-medium text-white px-1 py-1 rounded-xl hover:bg-white hover:bg-opacity-20"
            @click="editJob()"
            aria-label="Edit Job"
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </button>
          <div class="relative">
          <button class="heading-4 cursor-pointer text-white px-2 py-1 rounded-xl"  @click.stop="showActionsMenu = !showActionsMenu">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </button>
          <!-- Dropdown menu -->
            <div v-if="showActionsMenu" v-click-outside="closeActionsMenu" class="relative">
              <div class="bg-white absolute z-10 right-0 shadow-md rounded-md mt-2 p-3" >
                <div class="text-text2 font-medium">
                  <div class="p-2 text-text2 font-medium w-52">

                    <!-- Send Booking Confirmation Button -->
                    <!-- <div class="mb-3">
                      <Button
                      :btnSize="'medium'"
                      :textColor="'white'"
                      :btnColor="'blue1'"
                      :btnText="'Send Booking Confirmation'"
                      :className="'w-full'"
                      @buttonAction="sendBookingConf()"
                      />
                    </div> -->
                    
                    <!-- Generate Job Share Link Button -->
                    <div  v-if="jobDetails.jobLinkHashExpiryDate === '' && (userDetail.isAdmin || userDetail.isOwner)" class="mb-3">
                      <Button
                      :btnSize="'medium'"
                      :textColor="'white'"
                      :btnColor="'secondary'"
                      :btnText="'Generate Job Share Link'"
                      :className="'w-full'"
                      @buttonAction="GenerateJob()"
                      />
                    </div>
                    
                    <!-- Share Job Button -->
                    <div v-else-if="userDetail.isAdmin && userDetail.isOwner" class="relative mb-3">
                      <Button
                      :btnSize="'medium'"
                      :textColor="'white'"
                      :btnColor="'secondary'"
                      :btnText="'Share Job'"
                      :className="'w-full'"
                      @buttonAction="toggleMenuList()"
                      />
                      
                      <!-- Menu List (Positioned to the left of the "Share Job" button) -->
                      <div v-if="showMenuList" v-click-outside="closeActionsMenu" class="absolute right-40 top-0 mt-2 w-max bg-white shadow-md rounded-md p-3 z-20">
                        <div class="text-text2 font-medium">
                          <div class="p-2 cursor-pointer text-primary hover:bg-gray-100 flex items-center" @click="copyTextNoInput(jobDetails.jobShareLink)">
                            <i class="fas fa-copy"></i>
                            <span ref="jobUrl" class="pl-2">{{jobDetails.jobShareLink}}</span>
                          </div>
                          <div class="divider"></div>
                          <div class="p-2 cursor-pointer hover:bg-gray-100" @click="sharebutton(jobDetails.jobShareLink)">
                            <span class="py-1 text-text2">
                              <i class="fas fa-external-link text-primary"></i>
                              <span class="pl-2">Open URL</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Close or Reopen Job Buttons -->
                    <div :class="(userDetail.isAdmin || userDetail.isOwner) ? 'mb-3' : 'mb-0'">
                      <Button
                      v-if="!jobDetails.isClosed"
                      :btnSize="'medium'"
                      :textColor="'white'"
                      :btnColor="'warning'"
                      :btnText="'Close Job'"
                      :className="'w-full'"
                      @buttonAction="completeVisitBtn"
                      />
                      <Button
                      v-else
                      :btnSize="'medium'"
                      :textColor="'white'"
                      :btnColor="'gray3'"
                      :btnText="'Reopen Job'"
                      :className="'w-full'"
                      @buttonAction="isReOpenConfirm = true"
                      />
                    </div>

                    <!-- Delete Job Button -->
                    <div class="mb-0" v-if="userDetail.isAdmin || userDetail.isOwner">
                      <Button
                      :btnSize="'medium'"
                      :textColor="'white'"
                      :btnColor="'error'"
                      :btnText="'Delete Job'"
                      :className="'w-full'"
                      @buttonAction="isDeleteJob = true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> 
          </div>
        </div>
      </div>
    </div>
    <div v-if="visitDetail !== null">
      <div class="lg:grid grid-cols-3 gap-4">
        <div>
          <div class="text-text1  card rounded-xl bg-white mb-4 p-4">
            <div class="relative">
              <div class="">
                <!-- <p class=" font-semibold mb-1 text-gray4 heading-6"><span v-if="jobDetails.isVipJob" class="text-success heading-5 pr-1"><i class="fa-solid fa-crown"></i></span> Job # {{jobDetails.jobNumber}}</p> -->
                <div class=" font-semibold mb-1 2xl:flex justify-between">
                  <p class=" font-semibold mb-1 text-gray4 heading-6">Job # {{jobDetails.jobNumber}}</p>
                  <div class="font-normal heading-7">
                    <div class="flex items-center justify-between text-text2">
                      <div class="mb-1 flex items-center justify-center w-fit heading-7 whitespace-nowrap border text-primary border-primary rounded px-1 py-0.5  mr-1" v-if="jobDetails.isBillable">Billable</div>
                      <p>{{ visitDetail.visitStartDateTime | formatVisitRange(visitDetail.visitEndDateTime, setDisplayEstimation(visitDetail.visitEstimation)) }}</p>
                      <!-- Individual job type edit icon removed - use "Edit Job" button instead -->
                      <!-- <p> <span @click="jobTypeUpdate = true" class="pl-2 cursor-pointer text-primary heading-5"><i class="fa-solid fa-pen-to-square"></i></span></p> -->
                    </div>
                  </div>
                </div>
                <p v-if="jobDetails.isClosed" class=" text-warning font-semibold mb-1">Closed Job</p>
              </div>
              <div class="block">
              <div class="flex justify-between">
                <div class="">
                  <span v-if="jobDetails.customerHotNotes !== ''" class="text-error heading-4 pr-1"><i class="fa-brands fa-gripfire"></i></span>
                <span :class="`${userDetail.isAdmin || userDetail.isOwner ? 'cursor-pointer' : ''} text-primary font-semibold`" @click.stop="(userDetail.isAdmin || userDetail.isOwner) && customerDetail()">{{jobDetails.companyName}}</span>
                </div>
                <div v-if="jobDetails.customerHotNotes !== ''" class=" text-right">
                  <span class="cursor-pointer text-primary heading-7" @click.stop="showHotNOtes = !showHotNOtes"> {{showHotNOtes ? 'Hide' : 'Show'}} hot notes</span>
                </div>
              </div>
              <div v-if="showHotNOtes" class="">
                  <span class="cursor-pointer text-secondary">
                    {{jobDetails.customerHotNotes}}
                  </span>
                </div>
              <div v-if="jobDetails.customerContactNumber !== ''" class=" flex gap-4 mt-2">
                <span>{{jobDetails.customerContactNumber | phone}}</span>
                <div class="flex gap-4">
                  <a class="text-primary" :href="`tel:${jobDetails.customerContactNumber}`"><i class="fa-solid fa-phone-volume"></i></a>
                  <a class="text-primary" :href="`sms:${jobDetails.customerContactNumber}`"><i class="fa-solid fa-comment"></i></a>
                </div>
              </div>
              </div>
              <!-- <span @click="updateJobValue()" class="text-primary cursor-pointer absolute right-0 top-0"><i class="fa-solid fa-pen-to-square"></i></span> -->
              <div v-if="jobDetails.latitude !== 0 && jobDetails.longitude !== 0" class="">
                  <div class="flex justify-between items-center mb-2">
                      <p class="font-bold">Address</p>
                  </div>
                  <div class="">
                      <div class="flex whitespace-nowrap justify-between">
                        <div class="flex items-start">
                          <div>
                            <span @click="openMap(jobDetails.latitude, jobDetails.longitude)" class=" cursor-pointer text-primary "><i class="fa-solid fa-location-dot w-8"></i><span class="text-gray2">:</span></span> 
                          </div>
                          <div class="pl-1 relative">
                            
                              <p v-if="jobDetails.fullAddress !== ''" class="pr-4   font-bold text-text2 whitespace-pre-wrap cursor-pointer" @click="showJobDetail = !showJobDetail">
                               <span class=" border border-gray2 rounded-md whitespace-nowrap heading-7 px-1 py-0.5 mr-1">
                                {{jobDetails.addressTitle === '' ? 'Other' : jobDetails.addressTitle}}
                              </span>  {{jobDetails.fullAddress}}
                              </p>
                              <p v-if="jobDetails.fullAddress === ''" class="pr-4 flex flex-wrap font-bold text-text2 whitespace-pre-wrap cursor-pointer" @click="showJobDetail = !showJobDetail">
                              {{jobDetails.addressLine1}}
                              </p>
                              <div v-if="showJobDetail">
                                <p  class="text-text1 heading-6">
                                  <span v-if="jobDetails.houseNo !== ''">#: {{jobDetails.houseNo}}</span>
                                  <span v-if="jobDetails.floorNumber !== ''"> (Floor: {{jobDetails.floorNumber}})</span>
                                </p>
                                <p v-if="jobDetails.buildingName!== ''" class="text-text1 ">Bldg: {{jobDetails.buildingName}}</p>
                                <p v-if="jobDetails.directionNote!== ''" class="text-text1 whitespace-pre-wrap">Directions: {{jobDetails.directionNote}}</p>
                                <!-- <div class="p-1">
                                  <span @click="updateJobAddress()" class="text-primary cursor-pointer heading-5"><i class="fa-solid fa-pen-to-square"></i></span>
                                </div> -->
                              </div>
                            </div>
                          </div>
                          <div class="flex items-start">
                            <span v-if="userDetail.isAdmin || userDetail.isOwner">
                              <span  @click="updateJobAddress()" class="text-primary cursor-pointer"><i class="fa-solid fa-pen-to-square"></i></span>
                            </span>
                            <div class="ml-1" v-if="jobDetails.houseNo !== '' || jobDetails.floorNumber !== '' || jobDetails.buildingName!== '' || jobDetails.directionNote!== ''">
                              <span @click="showJobDetail = !showJobDetail" v-if="showJobDetail" class="text-primary cursor-pointer"><i class="fas fa-chevron-up"></i></span>
                            <p @click="showJobDetail = !showJobDetail" v-if="!showJobDetail" class="text-primary cursor-pointer"><i class="fas fa-chevron-down"></i></p>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
                  <div v-else class="mt-2">
                      <div class="flex whitespace-nowrap items-start relative" >
                        <div>
                          <span @click="openMap(orgDetail.latitude, orgDetail.longitude)" class=" cursor-pointer text-primary "><i class="fa-solid fa-location-dot w-4"></i><span class="text-gray2"></span></span>
                        </div>
                        <div class="pl-1">
                          <p class="text-gray4 heading-5">At Office</p>
                        </div>
                        <!-- <span @click="updateJobAddress()" class="text-primary cursor-pointer absolute right-0"><i class="fa-solid fa-pen-to-square"></i></span> -->
                      </div>
                  </div>
            </div>
            
            </div>
          <div class="text-text1  card rounded-xl bg-white mb-4 p-4">
            <div class=" relative">
              <p v-if="jobDetails.jobDescription !== ''" class="  font-bold mb-2">Instructions</p>
              <p v-else class="  font-bold">No Instructions</p>
              <span class="mb-0 text-gray4 whitespace-pre-line">
                {{jobDetails.jobDescription === '' ? '-' : (jobDetails.jobDescription.length > 125)? readMoreNote ?  jobDetails.jobDescription : jobDetails.jobDescription.substr(0, 125) : jobDetails.jobDescription}}
                <span v-if="jobDetails.jobDescription.length > 125" class="text-primary cursor-pointer heading-7" @click="readMoreNote = !readMoreNote">
                  {{readMoreNote === false ? 'Read More...' : 'Read Less...'}}</span>
              </span>
              <!-- <p class="text-gray4 whitespace-pre-line">{{jobDetails.jobDescription}}</p> -->
              <span @click="getsJobDetail()" class="pl-2 cursor-pointer text-primary absolute top-0 right-0"><i class="fa-solid fa-refresh"></i></span>
              <!-- Individual instruction edit icon removed - use "Edit Job" button instead (for description only, attachments can still be edited separately) -->
              <!-- <span @click="updateJob('notes', jobDetails.jobDescription, jobDetails.jobDescAttachmentDetail.attachmentList)" class="pl-2 cursor-pointer text-primary absolute top-0 right-0"><i class="fa-solid fa-pen-to-square"></i></span> -->
               <span 
                @click="updateJob('notes', jobDetails.jobDescription, jobDetails.jobDescAttachmentDetail.attachmentList)" 
                class="pl-2 cursor-pointer text-primary absolute top-0 right-10"
              >
                {{ jobDetails.jobDescAttachmentDetail.attachmentList === null ? '+ Add Attachment' : 'Add/Remove Attachment' }}
              </span>
            </div>
                        <!-- divider -->
            <div v-if="jobDetails.jobDescription !== ''" class="w-full border-t border-gray-200 my-4"></div>
            <!-- Only show if attachmentList is not null -->
          <div v-if="jobDetails.jobDescAttachmentDetail.attachmentList !== null" class="mt-2">

            <!-- 🔹 System Uploaded Attachments -->
            <div v-if="jobDetails.jobDescAttachmentDetail.attachmentList.some(a => a.addedById !== 0)">
              <p class="heading-6 mb-2">Staff Attachments:</p>
              <div class="flex gap-3" style="flex-wrap: wrap;">
                <div
                  class="card rounded-sm border-t border-gray-100 bg-white attachment-card cursor-pointer group relative"
                  style="width: 110px; height: 76px"
                  v-for="(attach, a) in jobDetails.jobDescAttachmentDetail.attachmentList.filter(a => a.addedById !== 0)"
                  :key="'user-' + a"
                  @click="showFullImage(attach)"
                >
                  <!-- IMAGE -->
                  <div v-if="tekeType(attach.fileType) === 'image'" class="text-center flex justify-center">
                    <img
                      :src="`${jobDetails.jobDescAttachmentDetail.pathPrefix}${attach.thumbPath}/image200x200.jpg`"
                      style="height: 60px;width: auto;"
                      class="scroll-img-view"
                    />
                  </div>

                  <!-- VIDEO -->
                  <div v-if="tekeType(attach.fileType) === 'video'" class="flex justify-center items-center w-full">
                    <img
                      :src="`${jobDetails.jobDescAttachmentDetail.pathPrefix}${attach.thumbPath}/image200x200.jpg`"
                      style="height: 60px;width: auto;"
                      class="scroll-img-view"
                    />
                    <img class="flex items-center text-4xl absolute text-white" height="35px" width="35px" src="@/assets/images/play.svg" alt="">
                  </div>

                  <!-- PDF -->
                  <div v-if="tekeType(attach.fileType) === 'pdf'" class="flex justify-center items-center w-full">
                    <div class="flex items-center text-primary text-4xl"><i class="fa-regular fa-file-pdf"></i></div>
                  </div>

                  <!-- OTHER -->
                  <div
                    v-if="tekeType(attach.fileType) !== 'image' && tekeType(attach.fileType) !== 'video' && tekeType(attach.fileType) !== 'pdf'"
                    class="flex justify-center items-center w-full"
                  >
                    <div class="flex items-center text-primary text-4xl"><i class="fa-regular fa-file"></i></div>
                  </div>

                  <!-- Upload Date -->
                  <div class="text-text2 text-center heading-8">{{ attach.uploadedOn | dateFilter1 }}</div>
                </div>
              </div>
            </div>
            <!-- divider -->
            <div class="w-full border-t border-gray-200 my-4"></div>
            <div v-if="jobDetails.jobDescAttachmentDetail.attachmentList.some(a => a.addedById === 0)" class="mt-4">
              <p class="heading-6 mb-2">User Attachments:</p>
              <!-- AnchorButton instead of Button -->
              <div class="flex gap-3" style="flex-wrap: wrap;">
                <div
                  class="card rounded-sm border-t border-gray-100 bg-white attachment-card cursor-pointer group relative"
                  style="width: 110px; height: 76px"
                  v-for="(attach, a) in jobDetails.jobDescAttachmentDetail.attachmentList.filter(a => a.addedById === 0)"
                  :key="'system-' + a"
                  @click="showFullImage(attach)"
                >
                  <!-- IMAGE -->
                  <div v-if="tekeType(attach.fileType) === 'image'" class="text-center flex justify-center">
                    <img
                      :src="`${jobDetails.jobDescAttachmentDetail.pathPrefix}${attach.thumbPath}/image200x200.jpg`"
                      style="height: 60px;width: auto;"
                      class="scroll-img-view"
                    />
                    <!-- <p><i class="absolute right-0 top-0 fas fa-users text-primary bg-white border border-gray1 p-1 rounded-full heading-8"></i></p> -->
                  </div>

                  <!-- VIDEO -->
                  <div v-if="tekeType(attach.fileType) === 'video'" class="flex justify-center items-center w-full">
                    <img
                      :src="`${jobDetails.jobDescAttachmentDetail.pathPrefix}${attach.thumbPath}/image200x200.jpg`"
                      style="height: 60px;width: auto;"
                      class="scroll-img-view"
                    />
                    <img class="flex items-center text-4xl absolute text-white" height="35px" width="35px" src="@/assets/images/play.svg" alt="">
                    <!-- <p><i class="absolute right-0 top-0 fas fa-users text-primary bg-white border border-gray1 p-1 rounded-full heading-8"></i></p> -->
                  </div>

                  <!-- PDF -->
                  <div v-if="tekeType(attach.fileType) === 'pdf'" class="flex justify-center items-center w-full">
                    <div class="flex items-center text-primary text-4xl"><i class="fa-regular fa-file-pdf"></i></div>
                    <!-- <p><i class="absolute right-0 top-0 fas fa-users text-primary bg-white border border-gray1 p-1 rounded-full heading-8"></i></p> -->
                  </div>

                  <!-- OTHER -->
                  <div
                    v-if="tekeType(attach.fileType) !== 'image' && tekeType(attach.fileType) !== 'video' && tekeType(attach.fileType) !== 'pdf'"
                    class="flex justify-center items-center w-full"
                  >
                    <div class="flex items-center text-primary text-4xl"><i class="fa-regular fa-file"></i></div>
                    <!-- <p><i class="absolute right-0 top-0 fas fa-users text-primary bg-white border border-gray1 p-1 rounded-full heading-8"></i></p> -->
                  </div>

                  <!-- Upload Date -->
                  <div class="text-text2 text-center heading-8">{{ attach.uploadedOn | dateFilter1 }}</div>
                </div>
              </div>
            </div>

          </div>

          </div>
          <div class="text-text1  card rounded-xl bg-white mb-4 p-4">
            <div class=" relative">
              <p  class="  font-bold mb-2">Assign member(s)</p>
              <div class=" flex gap-2 flex-wrap">
                <div class="mb-4 flex flex-wrap cursor-pointer
                " v-for="(user, index) in visitDetail.assignToList" :key="index" @click="callAdminStartStop(user)" >
                  <Chip :class="`${user.jobStartTime !== '' ? ' font-semibold' : ''}`" :textColor="`${user.jobStartTime !== '' ? 'primary' : ''}`" :iconClass="`${user.jobStartTime !== '' ? 'fa-solid fa-circle-play' : ''}`" v-if="activeUer !== user.userDetailId" :chipText="`${user.firstName}  ${user.lastName}`"/>
                  <Chip :class="`${user.jobStartTime !== '' ? ' font-semibold' : ''}`" :textColor="`${user.jobStartTime !== '' ? 'primary' : ''}`" :iconClass="`${user.jobStartTime !== '' ? 'fa-solid fa-circle-play' : ''}`" v-else :chipText="`Me`"/>
                </div> 
              </div>
              <!-- <div class="flex justify-between sm:grid grid-cols-2 text-primary font-bold">
                <div><span @click="isShowTimeLog = true" class=" cursor-pointer">Time Log</span></div>
                <div><span @click="isLocationView = true" class=" cursor-pointer">Location</span></div>
              </div>
              <span @click="showAddUpdateTeam = true" class="pl-2 cursor-pointer text-primary absolute top-0 right-0"><i class="fa-solid fa-pen-to-square"></i></span> -->
            </div>
          </div>
        </div>
        <div class="col-span-2">
           <div class="flex flex-col gap-4 mb-4">
            <div v-if="jobInvoiceLi.length > 0" class="card bg-white rounded-xl p-4 w-full">
              <p class=" text-text1 heading-4 font-bold mb-2"> Invoice</p>
              <div style="overflow-y: auto; white-space: nowrap;" class="">
                <div v-if="jobInvoiceLi.length > 0">
                    <div class="text-gray4  min-w-min border-b border-gray1 font-bold flex heading-7  px-3 py-3 items-center">
                        <div class="table_col w-32  flex items-center">
                        <span class="">{{titleObj[0].title}}</span>
                        </div>
                        <div class="table_col w-44  flex items-center">
                        <span class="">{{titleObj[1].title}}</span>
                        </div>
                        <div class="table_col w-44  flex items-center">
                        <span class="">{{titleObj[2].title}}</span>
                        </div>
                        <div class="table_col w-32  flex items-center">
                        <span class="">{{titleObj[3].title}}</span>
                        </div>
                        <div class="table_col w-32  flex items-center">
                        <span class="">{{titleObj[4].title}}</span>
                        </div>
                    </div>
                        
                        <div v-for="(data, index) in jobInvoiceLi" :key="index" @click="openInvoiceDetails(data.invoiceId)" :class="`${jobInvoiceLi.length - 1 > index  ? 'border-b border-gray1' : ''}`" class="min-w-min flex heading-5  bg-white  text-sm px-3 py-3 items-center hover:bg-gray1 cursor-pointer">
                        <div class="table_col w-32 ">
                            <div class="">
                            <p class="  text-text2">#{{data.invoiceNumber}}</p>
                            </div>
                        </div>
                        <div class="table_col w-44 ">
                            <div class="flex items-center">
                            <span class="  text-gray4 heading-6">{{data.grandTotal | amountOnlyNumber}}</span>
                            </div>
                        </div>
                        <div class="table_col w-44">
                            <div class="flex items-center">
                            <span class="  text-gray4 heading-6">{{data.invoiceDate | formatForDatePicker}}</span>
                            </div>
                        </div>
                        <div class="table_col w-32 ">
                            <div class="flex items-center">
                            <span class="  text-gray4 heading-6">{{data.dueDate | formatForDatePicker}}</span>
                            </div>
                        </div>
                        <div class="table_col w-32 ">
                            <div class="flex items-center">
                            <span :style="`color: ${data.statusColor};`" class=" text-gray4 heading-6">{{data.statusName}}</span>
                            </div>
                        </div>
                        </div>
                </div>
                <!-- <div v-else>
                  <NoRecords :alertMessage="` No records found.`" />
                </div> -->
              </div>
          </div>
          <div class="card bg-white rounded-xl p-4 w-full" v-else>
            <LineItems :detailData="{
              customerId:jobDetails.customerId,
              jobId:jobDetails.jobId,
              visitId:jobDetails.visitList[0]?.visitId || jobDetails.completeVisitList[0]?.visitId,
              jobTitle: jobDetails.jobTitle,
              visitNumber: 0,
              requestType: 'job',
              }" />
          </div>
          </div>
          <!-- <div  class="card rounded-xl bg-white mb-4 p-4" v-if="!jobDetails.isUnschedule">
            <VisitList />
          </div> -->
          <div class=" col-span-2">
          <div class="card bg-white rounded-xl p-4 mb-4">
              <div>
                  <div class="mb-4">
                      <Tabs :tabsList="tabTitle" />
                  </div>
                  <div v-if="selectedName === 'Notes'">
                    <div v-if="visitDetail !== null && canNotePermission" class="card rounded-xl bg-white mb-4 p-4">
                      <NotesList :detailId="jobDetails.visitList[0]?.visitId || jobDetails.completeVisitList[0]?.visitId" :requestType="'visit'" :noteTitle="'Visit Notes'" />
                    </div>
                  </div>
                  <div v-if="selectedName === 'Checklist'">
                    <div class="card p-4 bg-white rounded-xl mb-4">
                      <div class="text-text1">
                        <div class="flex items-center mb-2">
                          <p class="text-text1 font-bold heading-4 ">Visit Checklist</p>
                          <Button @buttonAction="openUpdateChecklist" :btnSize="'medium'" :textColor="'primary'" :btnColor="'white'" :btnText="''" :iconClass="'fa-solid fa-pen-to-square'" className="no-shadow-btn"/>
                        </div>
                        <div v-if="visitChecksList.length > 0">
                        <div v-for="(chl, ind) in visitChecksList" :key="ind" class="mb-2 ml-4" :class="`${visitChecksList.length - 1 > ind  ? 'border-b border-gray1' : ''}`">
                          <div class="mb-1 flex items-center">
                            <div style="width: 25px" class="text-primary"><i v-if="chl.checked" class="fa-solid fa-circle-check"></i><i v-else class="fa-regular fa-circle-check"></i></div>
                            {{chl.checkLiTitle}}</div>
                        </div>
                        </div>
                        <!-- <div v-else>
                          <NoRecords :alertMessage="` No records found.`" />
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div v-if="selectedName === 'Tools'">
                    <div class="card p-4 bg-white rounded-xl mb-4">
                      <div class="text-text1 mb-4">
                        <div class="flex items-center mb-2">
                          <p class="text-text1 font-bold heading-4 ">Visit Tools</p>
                          <AnchorButton @buttonAction="isUpdateToolist=true" :btnSize="'medium'" :textColor="'white'" :btnColor="'primary'" :btnText="'+ Add Tools'" class="ml-4"/>
                        </div>
                        <div v-if="visitDetail.toolList.length > 0">
                        <div v-for="(tool, ind) in visitDetail.toolList" :key="ind" class="mb-2" :class="`${visitDetail.toolList.length - 1 > ind  ? 'border-b border-gray1' : ''}`">
                          <p class="mb-1">{{tool.toolName}}</p>
                          <p class="mb-1 heading-7 text-text2">{{tool.toolDescription}}</p>
                        </div>
                        </div>
                        <!-- <div v-else>
                          <NoRecords :alertMessage="` No records found.`" />
                        </div> -->
                      </div>
                    </div>
                  </div>
              </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="popup_overlay px-4" v-if="isUpdateToolist">
      <div class="custom_dialog rounded-xl" style="width: 500px; overflow: auto; max-height: 90%;">
        <div class="relative bg-white">
          <div>
            <div class="bg-primary flex justify-between p-3 rounded-t-xl">
            <div class=" font-medium text-white heading-3">
                Tool list
            </div>
            <div @click="addNewTool=true" class=" font-medium text-white heading-3 cursor-pointer">
                Add New
            </div>
          </div>
             <div style="" class="p-4">
              <div class="mb-4 sm:mb-0">
                <div >
                <div v-for="(item, ch) in toolsList" :key="ch" :class="` ${toolsList.length - 1 >  ch ? 'border-b' : ''} py-2 mb-2 flex items-center cursor-pointer hover:bg-screen_bg`" @click="item.checked = !item.checked">
                   <div v-if="item.checked" style="width: 25px" class="text-primary"><i class="fa-solid fa-circle-check"></i></div>
                   <p v-else style="width: 25px" class="text-primary"></p>
                  <span>{{item.toolName}}</span>
                </div>
                
                </div>
              </div>
            </div>
            <div class="flex justify-end p-3">
              <div class="text-rigth flex gap-2">
                <Button :btnSize="'medium'" :textColor="'text1'" :btnColor="'gray1'" :btnText="'Cancel'" @buttonAction="isUpdateToolist=false"/>
                <Button :btnSize="'medium'" :textColor="'white'" :btnColor="'success'" :btnText="'Save'" @buttonAction="UpdateToollist"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popup_overlay px-4" v-if="addNewTool">
      <div class="custom_dialog rounded-xl" style="width: 500px; overflow: auto; max-height: 90%;">
        <div class="relative bg-white">
          <div>
            <div class="bg-primary flex justify-between p-3 rounded-t-xl">
            <div class=" font-medium text-white heading-3">
              Add new tool
            </div>
          </div>
             <div class="p-4">
              <div class="mb-4 sm:mb-0">
                <div >
                <div class="flex items-center">
                  <TextField class="w-full"
                  :inputId="`Toolnameid`"
                  :textMaxlength="100"
                  :inputext="toolNameText"
                  :placholderText="`Tool Name`"
                  :lableText="'Tool Name'"
                  :autoFocus="true"
                  @inputChangeAction="(data) => (toolNameText = data)"
                />
                
                
                </div>
                <div class="mt-4">
                  <TextAreaInput
                    :inputId="'diswcriptioncon'"
                    :inputext="toolDescription"
                    :placholderText="`Tool Description`"
                    :lableText="'Tool Description'"
                    :inputType="'text'"
                    :autoFocus="false"
                    :cols="50"
                    :rows="3"
                    :setReadOnly="false"
                    @inputChangeAction="(data) => toolDescription = data"  />
                </div>
                </div>
              </div>
            </div>
            <div class="flex justify-end p-3">
              <div class="text-rigth flex gap-2">
                <Button :btnSize="'medium'" :textColor="'text1'" :btnColor="'gray1'" :btnText="'Cancel'" @buttonAction="addNewTool=false"/>
                <Button :btnSize="'medium'" :disabled="toolNameText.trim() === ''" :textColor="'white'" :btnColor="'success'" :btnText="'Save'" @buttonAction="AddnewToool"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popup_overlay px-4" v-if="showListing">
      <div class="custom_dialog rounded-xl" style="width: 400px; overflow: auto; max-height: 90%;">
        <div class="relative bg-white">
          <div>
            <div class="bg-primary flex justify-between items-center p-3">
              <div class=" font-medium text-white heading-3">
                Check List
              </div>
            </div>
            <div class="p-2">
              <div v-for="(item, i) in showItemListing" :key="i + 'i'" class="card rounded-xl bg-white mb-2 p-3">
                <div class="flex items-center ">
                  <input type="checkbox" class="h-4 w-4 cursor-pointer text-primary" @click="checkboxCheck(item)" v-model="item.isSelected" >
                  <span class="pl-3 text-text2 heading-5 cursor-pointer" @click="checkboxCheck(item)">{{item.checkListTitle}}</span>
                </div>
              </div>
            </div>
            <div class="flex justify-end p-3">
              <div class="text-rigth flex gap-2">
                <Button :btnSize="'medium'" :textColor="'text1'" :btnColor="'gray1'" :btnText="'Cancel'" @buttonAction="nextStep(false)"/>
                <Button :btnSize="'medium'" :textColor="'white'" :btnColor="'success'" :btnText="'Next'" @buttonAction="nextStep(true)"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popup_overlay px-4" v-if="updateChecklist">
      <div class="custom_dialog rounded-xl" style="width: 500px; overflow: auto; max-height: 90%;">
        <div class="relative bg-white">
          <div>
            <div class="bg-primary flex justify-between p-3 rounded-t-xl">
            <div class=" font-medium text-white heading-3">
                Update Checklist
            </div>
          </div>
          <!-- Conditional Message -->
        <div v-if="showChecklistMessage && isClosingJob" class="p-4 text-error heading-5">
          To close the job, please check all items in the checklist.
        </div>
             <div class="p-4">
              <div class="mb-4 sm:mb-0">
                <div >
                <div v-for="(item, ch) in tempChecklist" :key="ch" :class="` ${visitChecksList.length - 1 >  ch ? 'border-b' : ''} py-2 mb-2 flex items-center`" @click="item.checked = !item.checked">
                  <CheckBoxInput :checkValue="item.checked" :label="``" :size="'small'" :disabled="false" @setIsActive="item.checked = !item.checked"/>
                  <span>{{item.checkLiTitle}}</span>
                </div>
                <div class="flex items-center mt-4">
                  <TextField class="w-full"
                  :inputId="`chekTitle`"
                  :textMaxlength="100"
                  :inputext="checkLiTitle"
                  :placholderText="`Chekclist Title`"
                  :lableText="''"
                  :autoFocus="true"
                  @inputChangeAction="(data) => (checkLiTitle = data)"
                />
                <span @click="addChecklist"
                    :class="`${checkLiTitle.trim() !== '' ? 'text-primary' : 'text-gray2' } cursor-pointer heading-3 pl-4`" >
                    Add
                    </span>
                </div>
                </div>
              </div>
            </div>
            <div class="flex justify-end p-3">
              <div class="text-rigth flex gap-2">
                <Button :btnSize="'medium'" :textColor="'text1'" :btnColor="'gray1'" :btnText="'Cancel'" @buttonAction="updateChecklist=false; showChecklistMessage = false; isClosingJob=false"/>
                <Button :btnSize="'medium'" :textColor="'white'" :btnColor="'success'" :btnText="'Save'" @buttonAction="UpdateCHekclist"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>    
    <FullImage :fileDate="fileDate" v-if="shoFullImage" :fileVaultId="fileVaultId" :fileType="fileType" :fileName="fileName" :isFromContactId="isFromContactId" />  
    <AddNewVisit v-if="isAddNewVisit" :detail="jobDetails"/>
    <UpdateJobTitleCust v-if="updateJobTitle" :detail="jobDetails" />
    <UpdateInsruction v-if="updateInstruction" :pathPrefix="jobDetails.jobDescAttachmentDetail.pathPrefix" :note="updateValue" :attachment="insArray" :reqType="reqType" />
    <UpdateJobType v-if="jobTypeUpdate" :detail="jobDetails" :visitDetail="visitDetail" :reqType="'jobType'" @updateJobTypeHandler="updateJobTypeHandler" />
    <SendBokkingCon :entitySlug="'job'" :detailId="parseInt(this.$route.params.jobId)" :customerId="jobDetails.customerId" v-if="isSendBookConf"  />
    <ConfirmBox v-if="isCloseJobConfirm"  :message="'Closing job will automatically completed visit that are not completed.'" :title="'Close Job?'" @confirmBoxHandler="handleCloseJobConfirm"/>
    <ConfirmBox v-if="isReOpenConfirm"  :message="''" :rbtnColor="'warning'" :title="'Are you sure to Reopen this job?'" @confirmBoxHandler="handleReOpenConfirm"/>
    <ConfirmBox v-if="isDeleteJob" :yesConfir="true" :inputLable='`Type "Yes" in below text box to delete job`'  :message="'Deleting job will also deleted all the linked visit including notes, attachment and time logs.'" :title="'Close Job?'" @confirmBoxHandler="handleDeleteJobConfirm"/>
    <AddressAdd :showAdditional="true" v-if="addNewjobAdd" />
    <UpdateJobAddress :jobDetail="addressObject" v-if="editJobAddress" :showAdditional="true" />
    <AdminStartStopVisit v-if="isAdminStarstop" :visitDetail="visitDetail" :selectedMemberData="selectedMemberData" />
    <TimeLog :visitDetail="visitDetail" v-if="isShowTimeLog" />
    <FullScreeenLocation :visitDetail="visitDetail" v-if="isLocationView" />
    <AddUpdateTeam :jobId="visitDetail.jobId" :selectedTeam="visitDetail.assignToList" :visitId="jobDetails.visitList[0].visitId || jobDetails.completeVisitList[0]?.visitId" v-if="showAddUpdateTeam" />
    <CompleteVisit :visitDetail="visitDetail" :checkListArr="showItemListing" v-if="isCompleteVisit" />
    <CreateJobPopup
      v-if="isEditJob"
      :showPopup="isEditJob"
      :isEditMode="true"
      :jobDetail="jobDetails"
      :visitDetail="visitDetail"
      @close="closeEditJob"
      @jobUpdated="handleJobUpdated"
    />
    <!-- <EditAddress :jobDetail="addressObject" v-if="editJobAddress" :showAdditional="true" /> -->
  </div>
</template>
<script>
var moment = require('moment')
import AddNewVisit from "@/View/job/visit/components/AddNewVisit.vue";
import AddressAdd from '@/View/components/AddressAdd.vue'
import Button from '@/View/components/globalButton.vue'
import SendBokkingCon from '@/View/components/SendBokkingCon.vue'
import MyJobApp from "@/api/MyJobApp.js";
// import VisitList from '@/View/job/visit/VisitList.vue';
import ConfirmBox from '@/View/components/ConfirmBox.vue'
import NotesList from '@/View/job/visit/NotesList.vue';
import UpdateJobTitleCust from '@/View/job/components/UpdateJobTitleCust.vue';
import UpdateInsruction from './components/UpdateInsruction.vue';
import UpdateJobType from './components/UpdateJobType.vue';
import {FilterPermissions} from '@/utils/Permissions.js'
// import EditAddress from '../components/EditAddress.vue';
import UpdateJobAddress from './components/UpdateJobAddress.vue';
import LineItems from './visit/components/LineItems.vue';
// import NoRecords from '../components/noRecords.vue';
import FullImage from '../endUserNewFlow/components/FullImage.vue';
import Tabs from '../../View/components/tabs.vue';
import Chip from '../../View/components/chip.vue';
import TextField from "@/View/components/textfield.vue";
import CheckBoxInput from '@/View/components/checkBoxInput.vue'
import TextAreaInput from '../../View/components/textAreaInput.vue';
import AdminStartStopVisit from '../job/visit/components/AdminStartStopVisit.vue';
import FullScreeenLocation from '../job/visit/components/FullScreeenLocation.vue';
import TimeLog from '../job/visit/components/TimeLog.vue';
import AddUpdateTeam from '../job/visit/components/AddUpdateTeam.vue';
import CompleteVisit from '../job/visit/components/CompleteVisit.vue';
import AnchorButton from "../components/AnchorButton.vue";
import CreateJobPopup from './components/CreateJobPopup.vue';

export default {
  name: "lead",
  components: {
    AddNewVisit,
    Button,
    AnchorButton,
    // EditAddress,
    AddressAdd,
    // VisitList,
    NotesList,
    UpdateJobTitleCust,
    UpdateInsruction,
    ConfirmBox,
    SendBokkingCon,
    UpdateJobAddress,
    UpdateJobType,
    LineItems,
    // NoRecords,
    FullImage,
    Tabs,
    Chip,
    TextField,
    CheckBoxInput,
    TextAreaInput,
    AdminStartStopVisit,
    FullScreeenLocation,
    TimeLog,
    AddUpdateTeam,
    CompleteVisit,
    CreateJobPopup
  },
  data() {
    return {
      userDetail: null,
      fileDate: '',
      isFromContactId: 0,
      readMoreNote: false,
      showJobDetail: false,
      isCard: true,
      visitCountVal: 0,
      attachmentArray: [],
      linkActive: '',
      showMenuList: false,
      isCustomerPermission: FilterPermissions('customer'),
      canNotePermission: FilterPermissions('visit_note'),
      orgDetail: {},
      isAddNewVisit: false,
      editJobAddress: false,
      addNewjobAdd: false,
      jobDetails: null,
      addressObject: null,
      updateJobTitle: false,
      updateInstruction: false,
      isCloseJobConfirm: false,
      isReOpenConfirm: false,
      isDeleteJob: false,
      isSendBookConf: false,
      reqType: '',
      updateValue: '',
      insArray: [],
      jobTypeUpdate: false,
      jobEdit: false,
      showHotNOtes: false,
      selectedItemList: [],
      jobInvoiceLi: [],
      jobInVoiceCount: 0,
      titleObj: [
          {title: 'Invoice Number', icon: '', sortName: ''},
          {title: 'Invoice Total', icon: '', sortName: ''},
          {title: 'Date', icon: '', sortName: ''},
          {title: 'Due Date', icon: '', sortName: ''},
          {title: 'Status', icon: '', sortName: ''},
        ],
      tabTitle: [
        {name: 'Notes', active: true, canViewPermission: true},
        {name: 'Checklist', active: false, canViewPermission: true},
        {name: 'Tools', active: false, canViewPermission: true},
      ],
      fileVaultId: 0,
      fileType: '',
      fileName: '',
      shoFullImage: '',
      selectedName: 'Notes',
      visitDetail: null,
      visitChecksList: [],
      tempChecklist: [],
      isUpdateToolist: false,
      addNewTool: false,
      toolsList: [],
      toolNameText: '',
      toolDescription: '',
      visitCheckList: [],
      activeUer: 0,
      updateChecklist: false,
      checkLiTitle: '',
      selectedMemberData: null,
      isAdminStarstop: false,
      isLocationView: false,
      isShowTimeLog: false,
      showAddUpdateTeam: false,
      visitItems: [],
      showListing: false,
      showinvoiceError: false,
      showItemListing: [],
      isCompleteVisit: false,
      showActionsMenu: false,
      showChecklistMessage: false,
      isClosingJob: false,
      isEditJob: false,
    };

  },
  created() {
    window.addEventListener("resize", this.resizeWindowHandler);
    const data = localStorage.getItem('jobUserInfo')
    this.userDetail = data ? JSON.parse(data) : {}
    this.activeUer = this.userDetail.userDetailId
  },
  computed: {
    safeVisitDetail() {
      return this.visitDetail || {}; // Fallback to empty object
    }
  },
  watch: {
    tempChecklist: {
      handler(newChecklist) {
        // Check if all items in tempChecklist are checked
        if (this.isClosingJob) {
          const allChecked = newChecklist.length > 0 && newChecklist.every(item => item.checked === true);
          this.showChecklistMessage = !allChecked;
        }      
      },
      deep: true // Watch for deep changes in the array (e.g., changes to item.checked)
    }
  },
  mounted() {
    this.resizeWindowHandler()
    this.invoiceListOfJob()
    setTimeout(() => {
      let temp = FilterPermissions('job')
      if (temp) {
        this.getsJobDetail(true)
      } else {
        this.$store.dispatch('ShowSubPopup', {status: true, title: `You don't have permission to show Job detail`})
      }
    }, 200);
      this.$root.$on('updateAddressHandler', (response, data) => {
        // // console.log('eeevvv updateAddressHandler', response, data)
      if (response && data !== null && this.editJobAddress) {
        this.addJobApi(data)
      }
      this.editJobAddress = false
    })
    this.$root.$on('adminVisitStartStopHandler', (response) => {
      // console.log('eeevvv adminVisitStartStopHandler', response)
      if (response && this.isAdminStarstop) {
        this.getVisitInfo()
      }
      this.isAdminStarstop = false
      document.body.style = 'overflow: visible;';
    })
    this.$root.$on('visitTimeLogHandler', () => {
      // console.log('eeevvv visitTimeLogHandler')
      this.isShowTimeLog = false
    })
    this.$root.$on('locationViewHandler', () => {
      // console.log('eeevvv locationViewHandler')
      this.isLocationView = false
    })
        this.$root.$on('addUpdateTeamHandler', (data) => {
      // console.log('eeevvv addUpdateTeamHandler', data)
      if (data && this.showAddUpdateTeam) {
       this.getVisitInfo()
      }
      this.showAddUpdateTeam = false
    })
    // this.$root.$on('addNewVisitHandler', (response) => {
    //   // console.log('eeevvv addNewVisitHandler', response)
    //   if (response) {
    //     this.getsJobDetail()
    //   }
    //   this.isAddNewVisit = false
    // })
    // this.$root.$on('addAddressHandler', (response, data) => {
    //   // console.log('eeevvv addAddressHandler', response, data)
    //   if (response && data !== null && this.addNewjobAdd) {
    //     this.addJobApi(data)
    //   }
    //   this.addNewjobAdd = false
    // })
    this.$root.$on('visitCount', (response) => {
      // console.log('eeevvv visitCount', response)
      this.visitCountVal = response
    })
    this.$root.$on('EditAddressHandler', (response, data) => {
      // console.log('eeevvv EditAddressHandler', response, data)
      if (response && data !== null && this.editJobAddress) {
        this.addJobApi(data)
        this.editJobAddress = false
      }
    })
    this.$root.$on('updateJobHandler', (data) => {
      // console.log('eeevvv updateJobHandler', data)
      if (data) {
        this.getsJobDetail()
        }
        this.updateJobTitle = false
        this.updateInstruction = false
    })
    this.$root.$on('bookingConfirmationHandler', () => {
      // console.log('eeevvv bookingConfirmationHandler')
      document.body.style = 'overflow: visible;'
        this.isSendBookConf = false
    })
    this.$root.$on('confirmBoxHandler', (data) => {
      // console.log('confirmBoxHandler:', data , 'isCloseJobConfirm:', this.isCloseJobConfirm);
      if (data && this.isCloseJobConfirm) {
        // console.log('Calling closeJobFinal'); // Debug
        this.closeJobFinal()
      }
      if (data && this.isReOpenConfirm) {
        this.reOpenJobs()
      }
      if (data && this.isDeleteJob) {
        this.deleteJobFinal()
      }
      this.isReOpenConfirm = false
      this.isCloseJobConfirm = false
      this.isCompleteVisit = false
      this.isDeleteJob = false
      document.body.style = 'overflow: visible;'
      // console.log('confirmBoxHandler completed, isCloseJobConfirm:', this.isCloseJobConfirm);
    })
     this.$root.$on('fullImageHandlerEnd', (response) => {
      // console.log('eeevvv fullImageHandlerEnd', response)
       console.log('response', response);
        this.shoFullImage = false
    })

    this.$root.$on('setNewTabActive', (index) => {
     // console.log('eeevvv setNewTabActive', index, 'isCloseJobConfirm:', this.isCloseJobConfirm, 'isCompleteVisit:', this.isCompleteVisit);
        if (this.isCloseJobConfirm || this.isCompleteVisit) {
          // console.log('Ignoring setNewTabActive due to open ConfirmBox or VisitComplete');
          return;
        }
        this.tabsSet(index);
    })
    this.$root.$on('completeVisitHandler', (data) => {
      // console.log('eeevvv completeVisitHandler', data)
      document.body.style = 'overflow: visible;'
      if (data && this.isCompleteVisit) {
       this.visitDetail = null
       this.getVisitInfo()
       this.getCheckList()
       this.isCloseJobConfirm = true;
      }
      this.isCompleteVisit = false
    })
    // this.getVisitInfo()
     this.$root.$on('getVisitItemsList', (data) => {
      // console.log('eeevvv getVisitItemsList', data)
       this.visitItems = data
        // console.log('this.visitItems', this.visitItems)
        document.body.style = 'overflow: visible;'
    })
    // Removed editJobHandler - now using direct event handlers from CreateJobPopup
  },
  beforeDestroy() {
    // console.log('jobDetail.vue: beforeDestroy called, component instance:', this.$options.name);
    this.$root.$off("fullImageHandlerEnd");
    this.$root.$off("updateAddressHandler");
    this.$root.$off("EditAddressHandler");
    // this.$root.$off("addNewVisitHandler");
    // this.$root.$off("addAddressHandler");
    this.$root.$off("visitCount");
    this.$root.$off("updateJobHandler");
    this.$root.$off("bookingConfirmationHandler");
    this.$root.$off("confirmBoxHandler");
    this.$root.$off("setNewTabActive");
    this.$root.$off("addUpdateTeamHandler");
    this.$root.$off("locationViewHandler");
    this.$root.$off("visitTimeLogHandler");
    this.$root.$off("getVisitItemsList");
    this.$root.$off("completeVisitHandler");
    this.$root.$off("adminVisitStartStopHandler");
    // Removed editJobHandler - now using direct event handlers from CreateJobPopup
  },
  methods: {
    resizeWindowHandler() {
      // console.log('window.innerWidth', window.innerWidth)
      this.screenWidth = window.innerWidth
      if (window.innerWidth <= 640) {
        this.isCard = false
      } else {
        this.isCard = true
      }
    },
    handleCloseJobConfirm (data) {
      if (data) {
        this.closeJobFinal();
      }
      this.isCloseJobConfirm = false;
      document.body.style = 'overflow: visible;';
    },
    handleReOpenConfirm (data) {
      if (data) {
        this.reOpenJobs();
      }
      this.isReOpenConfirm = false;
      document.body.style = 'overflow: visible;';
    },
    handleDeleteJobConfirm (data) {
      if (data) {
        this.deleteJobFinal();
      }
      this.isDeleteJob = false;
      document.body.style = 'overflow: visible;';
    },
    closeActionsMenu() {
      this.showActionsMenu = false;
      this.showMenuList = false
    },
    toggleMenuList() {
      this.showMenuList = !this.showMenuList;
    },
    openUpdateChecklist() {
      this.updateChecklist = true;
      this.checkLiTitle = '';
      this.isClosingJob = false; // Ensure not in closing job context
      this.showChecklistMessage = false;
      if (Array.isArray(this.visitChecksList)) {
        this.tempChecklist = JSON.parse(JSON.stringify(this.visitChecksList));
      } else {
        this.tempChecklist = [];
      }
    },
    tekeType (fileType) {
      let temp = fileType.split('/')
        // console.log('temp', temp)
        let type = ''
        if (temp[0] === 'image' ) {
            type = 'image'
        } else if (temp[0] === 'application' && temp[1] === 'pdf') {
          type = 'pdf'
        } else if (temp[0] === 'video' ) {
          type = 'video'
        }
        return type
    },
    openInvoiceDetails (invoiceId) {
      this.$router.push({name: 'invoiceDetails', params: {invoiceId: invoiceId}})
    },
    invoiceListOfJob () {
      this.$store.dispatch("SetLoader", {status: true,message: "Loading...",});
      MyJobApp.invoiceListOfVisitsAndJobWeb(
        0,
        50,
        parseInt(this.$route.params.jobId),
        (response) => {
          // console.log('response*************************************', response);
          this.jobInvoiceLi = response.Data.tableRow !== null ? response.Data.tableRow : []
          this.jobInVoiceCount = response.Data.count
            this.$store.dispatch('SetLoader', {status: false, message: ''})
          },
          (error) => {
            // console.log('error', error);
            this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
            this.$store.dispatch('SetLoader', {status: false, message: ''})
          }
      );
    },
    closeList () {
      this.showMenuList = false
    },
    reOpenJobs () {
      this.$store.dispatch("SetLoader", {status: true,message: "Loading...",});
      MyJobApp.reopenJob(
        parseInt(this.$route.params.jobId),
        (response) => {
            document.body.style = 'overflow: visible;'
            this.getsJobDetail()
            this.$store.dispatch('SetAlert', {showAlert: true, message: response.message, color: 'success'})
            this.$store.dispatch('SetLoader', {status: false, message: ''})
          },
          (error) => {
            // console.log('error', error);
            this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
            this.$store.dispatch('SetLoader', {status: false, message: ''})
          }
      );
    },
    selectText (element) {
      var range
      if (document.selection) {
        range = document.body.createTextRange()
        range.moveToElementText(element)
        range.select()
      } else if (window.getSelection) {
        range = document.createRange()
        range.selectNode(element)
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(range)
      }
    },
    copyTextNoInput () {
      this.selectText(this.$refs.jobUrl)
      document.execCommand('copy')
      this.$store.dispatch('SetAlert', {showAlert: true, message: 'Job url copied', color: 'success'})
    },
    sharebutton (data) {
      // // let url = this.$router.resolve({name: 'jd', params: {infoId: 0}})
      // let url = this.$router.resolve({name: 'jd', params: {infoId: 0}})
      // window.open(url.href, '_blank')
      window.open(data, '_blank')
    },
    GenerateJob () {
      this.$store.dispatch('SetLoader', {status: true, message: 'Generating...'})
      MyJobApp.GenerateJobShareLink(
        this.jobDetails.jobId,
        (response) => {
          this.getsJobDetail()
          this.$store.dispatch('SetLoader', {status: false, message: ''})
          this.$store.dispatch('SetAlert', {showAlert: true, message: response.message, color: 'success'})
        },
        (err) => {
          this.$store.dispatch('SetAlert', {showAlert: true, message: err.message, color: 'error'})
          this.$store.dispatch('SetLoader', {status: false, message: ''})
          }
        )
    },
    getJobsItemList () {
      // Check if jobDetails and visit lists are available
      // console.log("Calling getJobsItemList with jobDetails:", this.jobDetails);
      if (!this.jobDetails || (!this.jobDetails.visitList.length && !this.jobDetails.completeVisitList.length)) {
        console.warn('No visits available to fetch item list');
        this.$store.dispatch('SetAlert', {
          showAlert: true,
          message: 'No visits available to fetch items',
          color: 'error'
        });
        this.selectedItemList = [];
        return;
      }

      // Safely get visitId
      const visitId = this.jobDetails.visitList[0]?.visitId || this.jobDetails.completeVisitList[0]?.visitId;
      // console.log("getJobsItemList visitId:", visitId);
      if (!visitId) {
        console.warn('No valid visit ID found for fetching item list');
        this.$store.dispatch('SetAlert', {
          showAlert: true,
          message: 'Unable to retrieve visit ID for item list',
          color: 'error'
        });
        this.selectedItemList = [];
        return;
      }

      this.subTotal = 0;
      this.$store.dispatch('SetLoader', { status: true, message: 'Loading...' });
      MyJobApp.getVisitItemList(
        visitId,
        this.jobDetails.jobId,
        response => {
          this.selectedItemList = response.Data.tableRow !== null ? response.Data.tableRow : [];
          // console.log('getJobsItemList response:', response.Data.tableRow);
          this.$store.dispatch('SetLoader', { status: false, message: '' });
        },
        () => {
          this.resetPaginationValues = false;
          this.$store.dispatch('SetLoader', { status: false, message: '' });
        }
      );
    },
    updateJobTypeHandler (response) {
      if (response) {
        this.getsJobDetail()
      }
      this.jobTypeUpdate = false
    },
    setDisplayEstimation (value) {
      let estimation = value
      let hours = Math.floor(estimation / 60); // Get the whole number of hours
      let min = estimation % 60; // Get the remaining minutes
      let minutes = Math.round(min); // Get the remaining minutes
      let formattedTime = `${ hours > 0 ? hours.toString().padStart(2, '0') + ' hr' : ''} ${hours > 0 && minutes > 0 ? "," : ''} ` + ` ${minutes > 0 ? ` ${minutes.toString().padStart(2, '0')} mins` : ''}`;

      return formattedTime
    },
    customerDetail () {
      if (this.isCustomerPermission) {
        this.$router.push({name: 'customerDetails', params: {customerId: this.jobDetails.customerId}})
      } else {
        this.$store.dispatch('ShowSubPopup', {status: true, title: `You don't have permission to Open Customer Detail`})
      }
    },
    addNewAddress () {
      this.addNewjobAdd = true
    },
    addNewVisit () {
      this.isAddNewVisit = true
      // this.$root.$emit('fromDetailScheduleVisit', true)
    },
    sendBookingConf () {
      document.body.style = 'overflow: hidden;'
      this.isSendBookConf = true
    },
    updateJobAddress () {
      this.editJobAddress = true
      console.log('addressObj', this.addressObject)
    },
    updateJobValue () {
      this.updateJobTitle = true
    },
    updateJob (type, value, data) {
      this.reqType = type
      this.updateValue = value
      if (data !== null) {
        this.insArray = this.attachmentArray
      }
      this.updateInstruction = true
    },

    editJob () {
      this.isEditJob = true
      this.showActionsMenu = false
      document.body.style = 'overflow: hidden;'
      console.log('addressObj', this.addressObject)
      console.log('addressObj', this.jobDetails)
    },
    closeEditJob() {
      this.isEditJob = false
      document.body.style = 'overflow: visible;'
    },
    handleJobUpdated(jobId) {
      console.log('Job updated:', jobId);
      this.isEditJob = false
      document.body.style = 'overflow: visible;'
      this.getsJobDetail(true)
    },
    openMap (lat, lng) {
     let url = 'https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lng
      window.open(url, '_blank')
    },
    addJobApi (data) {
      this.$store.dispatch("SetLoader", { status: true, message: "Loading..." });
      let SendObj = {
        jobId: parseInt(this.$route.params.jobId),
        addressLine1: data.addressLine1,
        addressLine2: data.addressLine2,
        city: data.city,
        state: data.state,
        zip: data.zip,
        country: data.country,
        latitude: data.latitude,
        longitude: data.longitude,
        geofenceRangeDiameter: data.selectedRadius,
        fullAddress: data.fullAddress,
        houseNo: data.houseNo,
        floorNumber: data.floorNumber,
        buildingName: data.buildingName,
        directionNote: data.directionNote,
        contactNumber: data.contactNumber,
        contactName: data.contactName,
        addressTitle: data.addressTitle
      }
      MyJobApp.addNewJobLocationWeb(
        SendObj,
        (response) => {
          this.addNewjobAdd = false
          this.getsJobDetail()
          this.$store.dispatch("SetLoader", { status: false, message: "" });
          this.$store.dispatch('SetAlert', {showAlert: true, message: response.message, color: 'success'})
        },
        (err) => {
          this.$store.dispatch('SetAlert', {showAlert: true, message: err.message, color: 'error'})
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
      // addNewJobLocationWeb
    },
    getsJobDetail(getItems) {
      // console.log("Calling getsJobDetail with getItems:", getItems); // Debug
      this.$store.dispatch("SetLoader", { status: true, message: "Loading..." });
      MyJobApp.getJobDetail(
        parseInt(this.$route.params.jobId),
        (response) => {
          // console.log("Callback received response:", response); // Debug
          this.jobDetails = response.Data;
          this.addressObject = response.Data;
          let currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);
          currentDate = new Date(currentDate);

          if (this.jobDetails.jobDescAttachmentDetail.attachmentList !== null) {
            this.attachmentArray = [];
            this.jobDetails.jobDescAttachmentDetail.attachmentList.map(a => {
              let temp = a.fileType.split('/');
              let type = '';
              if (temp[0] === 'image') {
                type = 'image';
              } else if (temp[0] === 'application' && temp[1] === 'pdf') {
                type = 'pdf';
              } else if (temp[0] === 'video') {
                type = 'video';
              }
              this.attachmentArray.push({ ...a, docType: type });
            });
          }

          if (this.jobDetails.latitude === 0 && this.jobDetails.longitude === 0) {
            this.$store.dispatch("SetLoader", { status: true, message: "Loading..." });
            MyJobApp.getOrgDetail(
              (response) => {
                // console.log("getsJobDetail response:", response);
                // console.log("visitList:", response.Data.visitList);
                // console.log("completeVisitList:", response.Data.completeVisitList);
                this.orgDetail = response.Data;
                this.addressObject = this.orgDetail;
                if (getItems && (this.jobDetails.visitList.length > 0 || this.jobDetails.completeVisitList.length > 0)) {
                  // console.log("Calling getJobsItemList with visitId:", this.jobDetails.visitList[0]?.visitId || this.jobDetails.completeVisitList[0]?.visitId);
                  this.getJobsItemList();
                } else if (getItems) {
                  console.warn('Skipping getJobsItemList: No visits available');
                  this.selectedItemList = [];
                }
                this.$store.dispatch("SetLoader", { status: false, message: "" });
              },
              (err) => {
                console.error("Error in getsJobDetail:", err);
                this.$store.dispatch('SetAlert', { showAlert: true, message: err.message, color: 'error' });
                this.$store.dispatch("SetLoader", { status: false, message: "" });
              }
            );
          }

          var startTime = moment(new Date());
          var endTime = moment(new Date(this.jobDetails.jobLinkHashExpiryDate));
          // console.log('diffInHours startTime', startTime);
          // console.log('diffInHours endTime', endTime);

          if (endTime.isBefore(startTime)) {
            this.jobDetails.jobShareLink = '';
            this.jobDetails.jobLinkHashExpiryDate = '';
          }

          // Only call getJobsItemList if getItems is true and a valid visit exists
          if (getItems && (this.jobDetails.visitList.length > 0 || this.jobDetails.completeVisitList.length > 0)) {
            this.getJobsItemList();
          } else if (getItems) {
            console.warn('Skipping getJobsItemList: No visits available');
            this.selectedItemList = [];
          }

          this.getVisitInfo();
          this.getCheckList();
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        },
        (err) => {
          console.error("Error in getsJobDetail:", err); // Debug
          this.$store.dispatch('SetAlert', { showAlert: true, message: err.message, color: 'error' });
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    closeJobFinal() {
      this.$store.dispatch("SetLoader", {status: true,message: "Loading...",});
      MyJobApp.closeJob(
        parseInt(this.$route.params.jobId),
        (response) => {
            document.body.style = 'overflow: visible;'
            this.getsJobDetail(false)
            this.$store.dispatch('SetAlert', {showAlert: true, message: response.message, color: 'success'})
            this.$store.dispatch('SetLoader', {status: false, message: ''})
          },
          (error) => {
            // console.log('error', error);
            this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
            this.$store.dispatch('SetLoader', {status: false, message: ''})
          }
      );
    },
    deleteJobFinal() {
      this.$store.dispatch("SetLoader", {status: true,message: "Loading...",});
      MyJobApp.deleteJob(
        parseInt(this.$route.params.jobId),
        (response) => {
          this.$router.push({name: 'job'})
            document.body.style = 'overflow: visible;'
            this.$store.dispatch('SetAlert', {showAlert: true, message: response.message, color: 'success'})
            this.$store.dispatch('SetLoader', {status: false, message: ''})
          },
          (error) => {
            // console.log('error', error);
            this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
            this.$store.dispatch('SetLoader', {status: false, message: ''})
          }
      );
    },
    showFullImage (data) {
        this.fileVaultId = data.fileVaultId
        this.fileType = this.tekeType(data.fileType)
        this.fileName = data.displayFileName
        this.isFromContactId = data.addedById
        this.fileDate = data.uploadedOn
        this.shoFullImage = true
    },
    tabsSet (index) {
      // console.log('eeevvv setNewTabActive', index, 'isCloseJobConfirm:', this.isCloseJobConfirm, 'isCompleteVisit:', this.isCompleteVisit);
         const wasClosingJob = this.isClosingJob;
         const wasConfirmBoxOpen = this.isCloseJobConfirm;
         const wasCompleteVisit = this.isCompleteVisit;
         this.tabTitle.forEach((element, i) => {
           if (index === i) {
             element.active = true;
             this.selectedName = element.name;
           } else {
             element.active = false;
           }
         });
         this.isClosingJob = wasClosingJob;
         this.isCloseJobConfirm = wasConfirmBoxOpen;
         this.isCompleteVisit = wasCompleteVisit;
         // console.log('tabsSet completed - isCloseJobConfirm:', this.isCloseJobConfirm, 'isCompleteVisit:', this.isCompleteVisit, 'selectedName:', this.selectedName);
    },
    getCheckList () {
      // Check if jobDetails and visit lists are available
      if (!this.jobDetails || (typeof this.jobDetails.visitList === 'undefined' && typeof this.jobDetails.completeVisitList === 'undefined')) {
        console.warn('No job details or visit lists available to fetch checklist');
        this.$store.dispatch('SetAlert', {
          showAlert: true,
          message: 'No job details or visits available to fetch checklist',
          color: 'error'
        });
        this.visitCheckList = [];
        this.$store.dispatch('SetLoader', { status: false, message: '' });
        return;
      }

      // Safely get visitId
      const visitId = this.jobDetails.visitList[0]?.visitId || this.jobDetails.completeVisitList[0]?.visitId;
      if (!visitId) {
        console.warn('No valid visit ID found for fetching checklist');
        this.$store.dispatch('SetAlert', {
          showAlert: true,
          message: 'Unable to retrieve visit ID for checklist',
          color: 'error'
        });
        this.visitCheckList = [];
        this.$store.dispatch('SetLoader', { status: false, message: '' });
        return;
      }

      // console.log('Fetching checklist for visitId:', visitId);
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      MyJobApp.GetChecklistInVisitDetail(
        visitId,
        response => {
          let temp = response.Data.tableRow !== null ? response.Data.tableRow : []
          temp.forEach(element => {
            if (element.isItemChecked === true) {
              element.isSelected = true
            } else {
              element.isSelected = false
            }
          });
          this.visitCheckList = temp
          this.$store.dispatch('SetLoader', {status: false, message: ''})
        },
        (err) => {
          this.$store.dispatch('SetAlert', {showAlert: true, message: err.message, color: 'error'})
          this.$store.dispatch('SetLoader', {status: false, message: ''})
        }
      )
    },
    getVisitInfo () {
      const visitId = this.jobDetails.visitList[0]?.visitId || this.jobDetails.completeVisitList[0]?.visitId;
      if (!visitId) {
        console.error("No valid visit ID found");
        this.$store.dispatch('SetAlert', {
          showAlert: true,
          message: "No valid visit found",
          color: 'error'
        });
        this.$store.dispatch('SetLoader', { status: false, message: '' });
        return;
      }
      this.visitDetail = null
      // this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      // // console.log("visiId", this.jobDetails.visitList[0].visitId)
      MyJobApp.getVisitDetail(
        // parseInt(this.$route.params.visitId),
        visitId,
        response => {
          this.visitDetail = response.Data;
          // console.log("Visit Detail:", response.Data); // Debug
          let temp = response.Data.visitCheckList !== '' ? JSON.parse(response.Data.visitCheckList) : [];
          temp.forEach(e => {
            e.checked = e.answer ? e.answer === 'Yes' ? true : false : false;
          });
          this.$set(this, 'visitChecksList', temp);
          // console.log('Updated visitChecksList:', this.visitChecksList);
          response.Data.assignToList.forEach(data => {
            if (data.userDetailId === this.activeUer && data.jobStartTime !== '') {
              this.userStartTime = data.jobStartTime;
              this.startVisit(data.jobStartTime);
            }
          });
          const startTime = moment(response.Data.visitStartDateTime);
          const endTime = moment(response.Data.visitEndDateTime);
          const hoursDiff = endTime.diff(startTime, 'hours');
          const minutesDiff = endTime.diff(startTime, 'minutes') % 60;
          if ((hoursDiff === 23 && minutesDiff === 59) || (hoursDiff === 24 && minutesDiff === 0)) {
            this.allDay = true;
          } else {
            this.allDay = false;
          }
          this.getToolList();
          // this.$store.dispatch('SetLoader', { status: false, message: '' });
        },
        err => {
          console.error("Visit Info Error:", err);
          this.$store.dispatch('SetAlert', { showAlert: true, message: err.message, color: 'error' });
          this.$store.dispatch('SetLoader', { status: false, message: '' });
        }
      )
    },
    getToolList () {
    this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      MyJobApp.GetToolsList(
        response => {
          this.toolsList = []
          if (response.Data !== null) {
            response.Data.forEach(e => {
              const findex = this.visitDetail.toolList.findIndex(x => x.toolName === e.toolName)
              if (findex > -1) {
                this.toolsList.push({...e, checked: true})
              } else {
                  this.toolsList.push({...e, checked: false})
              }
            });
            this.visitDetail.toolList.forEach(e => {
              const findex = response.Data.findIndex(x => x.toolName === e.toolName)
              // console.log('check 1111', findex);
              if (findex < 0) {
                this.toolsList.push({...e, checked: true})
              }
            });
          }
          this.$store.dispatch('SetLoader', {status: false, message: ''})
        },
        () => {
          this.$store.dispatch('SetLoader', {status: false, message: ''})
        }
      )
    },
    UpdateToollist () {
      let toolli = []
      const visitId = this.jobDetails.visitList[0]?.visitId || this.jobDetails.completeVisitList[0]?.visitId;
      this.toolsList.forEach(e => {
        if (e.checked) {
          toolli.push({
          toolMasterId: 0,
          toolName: e.toolName,
          toolDescription: e.toolDescription,
          isPickedUp: e.checked,
          isPickedUpUser: this.activeUer,
          pickedUpDateTime: '',
        })
        }
      });
      let data = {
          jobId: this.visitDetail.jobId,
          visitId: visitId,
          toolList: toolli
        }

      // console.log('data', data);

      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      MyJobApp.updateVisitToolPicWeb(
        data,
        response => {
          this.getVisitInfo()
          this.isUpdateToolist = false
          this.$store.dispatch('SetLoader', {status: false, message: response.message})
        },
        (err) => {
          this.$store.dispatch('SetAlert', {showAlert: true, message: err.message, color: 'error'})
          this.$store.dispatch('SetLoader', {status: false, message: ''})
        }
      )
    },
    AddnewToool () {
      if (this.toolNameText.trim() !== '') {
        this.toolsList.push({
          toolMasterId: 0,
          jobVisitToolMappId: 0,
          toolName: this.toolNameText,
          toolDescription: this.toolDescription,
          checked: true,
          isPickedUpUser: 0,
          pickedUpDateTime: new Date().toUTCString(),
        })
      }
      this.addNewTool = false
      this.toolDescription = ''
      this.toolDescription = ''
    },
    callAdminStartStop (userData) {
      this.selectedMemberData = userData
      this.isAdminStarstop = true
    },
    UpdateCHekclist () {
      // console.log('UpdateCHekclist called - isClosingJob:', this.isClosingJob, 'isCloseJobConfirm:', this.isCloseJobConfirm);
      const allChecked = this.tempChecklist.length > 0 && this.tempChecklist.every(item => item.checked === true);

      // If in closing job context and not all items are checked, show error and stop
      if (this.isClosingJob && !allChecked) {
        this.showChecklistMessage = true;
        return;
      }
      // Safely get visitId
      const visitId = this.jobDetails.visitList[0]?.visitId || this.jobDetails.completeVisitList[0]?.visitId;
      if (!visitId) {
        // console.log("visitId Not found")
      }
      let checkli = []
      this.tempChecklist.forEach(e => {
        checkli.push({
          checkLiTitle: e.checkLiTitle,
          answer: e.checked ? 'Yes' : ''
        })
      });
      // console.log('Checklist sent to API:', checkli); // Debug the payload
      // this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      MyJobApp.updateVisitChecklist(
        visitId,
        checkli,
          response => {
            console.log('API response:', response); // Debug the response
            this.$set(this, 'visitChecksList', [...this.tempChecklist]); // Use Vue.set for reactivity
            this.updateChecklist = false
            this.showChecklistMessage = false; // Reset the flag
            if (this.isClosingJob && allChecked) {
              this.updateChecklist = false
              this.isCompleteVisit = true; // Show the ConfirmBox
              document.body.style = 'overflow: hidden;'; // Ensure modal overlay
            }
            this.isClosingJob = false; // Reset the closing job flag
            this.getVisitInfo(); // Refresh data from backend
            // this.$store.dispatch('SetLoader', {status: false, message: response.message})
          },
          (err) => {
            this.$store.dispatch('SetAlert', {showAlert: true, message: err.message, color: 'error'})
            this.$store.dispatch('SetLoader', {status: false, message: ''})
          }
        )
    },
    addChecklist () {
      this.tempChecklist.push(
        {
          answer: '',
          checkLiTitle: this.checkLiTitle.trim(),
          checked: false,
        }
      )
      this.checkLiTitle = ''
      const allChecked = this.tempChecklist.length > 0 && this.tempChecklist.every(item => item.checked === true);
      this.showChecklistMessage = !allChecked;
    },
    completeVisitBtn () {
      
      this.updateChecklist = false;
      this.showListing = false;
      this.showinvoiceError = false;
      this.showChecklistMessage = false;
      
      this.selectedItemList = [];
      // Check if jobDetails and visit lists are available
      if (!this.jobDetails || (!this.jobDetails.visitList.length && !this.jobDetails.completeVisitList.length)) {
        this.$store.dispatch('SetAlert', {
          showAlert: true,
          message: 'No visits available to close the job',
          color: 'error'
        });
        return;
      }
      
      // Safely get visitId
      const visitId = this.jobDetails.visitList[0]?.visitId || this.jobDetails.completeVisitList[0]?.visitId;
      if (!visitId) {
        this.$store.dispatch('SetAlert', {
          showAlert: true,
          message: 'Unable to retrieve visit ID',
          color: 'error'
        });
        return;
      }
      if (this.visitChecksList.length > 0) {
        const allChecked = this.visitChecksList.every(item => item.checked === true);
        // console.log("All checklist items checked:", allChecked); // Debug
        if (!allChecked) {
          this.isClosingJob = true; // Set flag to indicate closing job context
          this.showChecklistMessage = true;
          this.updateChecklist = true;
          this.checkLiTitle = '';
          if (Array.isArray(this.visitChecksList)) {
            this.tempChecklist = JSON.parse(JSON.stringify(this.visitChecksList));
          } else {
            this.tempChecklist = [];
          }
          return; // Stop further execution
        } else {
          console.log('completeVisitBtn called');
          this.isCompleteVisit = true
        }
      }

      this.isClosingJob = false;
      this.showChecklistMessage = false;
      if (this.visitCheckList.length > 0) {
        this.showItemListing = JSON.parse(JSON.stringify(this.visitCheckList));
        this.showListing = true;
        document.body.style = 'overflow: hidden;';
      } else {
        if (this.visitDetail.invoiceId === 0 && this.visitItems.length === 0) {
          // this.isCloseJobConfirm = true;
          this.isCompleteVisit = true
          document.body.style = 'overflow: hidden;'; // Ensure modal overlay
        }
      }
    },
    nextStep (data) {
      if (data) {
        if (this.visitDetail.invoiceId === 0 && this.visitItems.length === 0) {
          this.showinvoiceError = true
        } else {
          // this.isCloseJobConfirm = true
          this.isCompleteVisit = true
        }
      } else {
        document.body.style = 'overflow: visible;'
      }
      this.showListing = false
    },
  }
};
</script>
<style scoped>
.scroll-img-view{
  height: 104px;
}
.zIndex {
  z-index: 100 !important;
}
</style>